import { render, staticRenderFns } from "./CommissionsTable.vue?vue&type=template&id=6103c2fe&scoped=true&lang=pug&"
import script from "./CommissionsTable.vue?vue&type=script&lang=js&"
export * from "./CommissionsTable.vue?vue&type=script&lang=js&"
import style0 from "./CommissionsTable.vue?vue&type=style&index=0&id=6103c2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6103c2fe",
  null
  
)

export default component.exports